export default {
    zh_CN: '简体中文',
    en_GB: 'English',
    en_US: 'English(US)',
};
